// src/components/canine-teeth/SavedSessionsGallery.js

import React, { useEffect, useState, useCallback } from 'react';
import { getSessionsByEmailAndTool, deleteSession } from '../../indexedDB';
import PropTypes from 'prop-types';
import '../tools.css';
import { getSubImagesByOriginalImageNameAndTool } from '../../indexedDB';

function SavedSessionsGallery({ onSelectSession, sessionsCount, userEmail, userInfo }) { // Aggiunta di userInfo
  const [savedSessions, setSavedSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessions = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const tool = 'original-image-i3m'; // Assicurati che il tool sia corretto
        const sessions = await getSessionsByEmailAndTool(userEmail, tool);
        console.log('Sessioni originali recuperate:', sessions);
        setSavedSessions(sessions);
      } catch (error) {
        console.error('Errore nel recuperare le sessioni:', error);
        setError('Error fetching sessions. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    if (userEmail) { // Assicurati di avere l'email dell'utente prima di chiamare fetchSessions
      fetchSessions();
    } else {
      setSavedSessions([]);
      setIsLoading(false);
    }
  }, [sessionsCount, userEmail]);

  
  const handleSelectSession = useCallback(async (originalSession) => {
    try {
      const toolForSubImages = 'i3m';
      const subImages = await getSubImagesByOriginalImageNameAndTool(userEmail, originalSession.subImage.name, toolForSubImages);
      if (subImages.length === 0) {
        alert('No sub-images found for this original image.');
        return;
      }
      // Pass both the original session and subImages
      onSelectSession(originalSession, subImages);
    } catch (error) {
      console.error('Error fetching sub-images:', error);
      alert('Error fetching sub-images. Please try again later.');
    }
  }, [onSelectSession, userEmail]);


  const handleDeleteSession = useCallback(async (sessionName) => {
    try {
      await deleteSession(sessionName, userEmail); // Passa anche userEmail
      // Aggiorna lo stato delle sessioni dopo la cancellazione
      setSavedSessions((prevSessions) =>
        prevSessions.filter((session) => session.subImage.name !== sessionName)
      );
    } catch (error) {
      console.error('Errore nella cancellazione della sessione:', error);
      alert('Error deleting session. Please try again later.');
    }
  }, [userEmail]);

  if (isLoading) {
    return <div className="loading-container">Loading sessions...</div>;
  }

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  if (savedSessions.length === 0) {
    return <div className="no-sessions">No saved sessions</div>;
  }

  return (
    <div className="gallery-container">
      <h3 className="gallery-title">Saved Images Gallery</h3>
      <div className="gallery-grid">
        {savedSessions.map((session) => {
          // Verifica che la sessione sia valida
          if (
            !session ||
            !session.subImage ||
            (session.tool !== 'original-image-i3m' &&
              (!session.subImage.downloadURL ||
                typeof session.subImage.downloadURL !== 'string' ||
                !session.subImage.downloadURL.startsWith('https://')))
          ) {
            console.error('Sessione non valida o immagine non disponibile:', session);
            return (
              <div key={session.id || session.subImage.name} className="gallery-card invalid-session">
                <p>No sessions or session unavaible</p>
                <button
                  onClick={() => handleDeleteSession(session.subImage.name)}
                  className="delete-button"
                >
                  Elimina
                </button>
              </div>
            );
          }

          return (
            <div key={session.id} className="gallery-card">
              <img
                src={session.subImage.downloadURL || session.subImage.dataURL} // Usa downloadURL o dataURL
                alt={`Immagine Originale ${session.id}`}
                className="gallery-image"
                onClick={() => handleSelectSession(session)}
              />
              <p className="gallery-image-name">{session.subImage.name}</p>
              {session.realAge && (
                <p className="gallery-image-details">Real Age: {session.realAge}</p>
              )}
              <button
                onClick={() => handleDeleteSession(session.subImage.name)}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Definizione dei tipi delle props per una migliore manutenibilità e debugging
SavedSessionsGallery.propTypes = {
  onSelectSession: PropTypes.func.isRequired,
  sessionsCount: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
  userInfo: PropTypes.object, // Nuova prop se necessaria
};

export default SavedSessionsGallery;
